module.exports = __webpack_public_path__ + "static/media/logowelcomversion.25937ff1.png";